var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Freewheel = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    if (this.plugin.getAdapter()) {
      return this.plugin.getAdapter().getPlayhead()
    }
    return this.player.videoEl.currentTime
  },

  /** Override to return video duration */
  getDuration: function () {
    if (this.plugin.getAdapter()) {
      return this.plugin.getAdapter().getDuration()
    }
    return this.player.videoEl.duration
  },

  /** Override to return title */
  getTitle: function () {
    if (this.titles) {
      return this.titles[(this.plugin.requestBuilder.lastSent.adNumber || 1) - 1]._adId
    }
    return "unknown"
  },

  /** Override to return resource URL. */
  getResource: function () {
    if (this.plugin.getAdapter()) {
      return this.plugin.getAdapter().getResource()
    }
    return this.player.videoEl.currentSrc
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return tv.freewheel.SDK.version
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return "Freewheel"
  },

  getPosition: function () {
    return this.position
  },

  /** Register listeners to this.player. */
  registerListeners: function () {

    // Enable playhead monitor
    this.monitorPlayhead(true, false)

    // References
    this.references = []
    this.references[tv.freewheel.SDK.EVENT_AD_IMPRESSION_END] = this.endedListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_AD_IMPRESSION] = this.playListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_AD_PAUSE] = this.pauseListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_AD_RESUME] = this.resumeListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_AD_SKIPPED] = this.skipListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_AD] = this.logListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_SLOT_STARTED] = this.slotListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_AD_CLOSE] = this.closeListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_SLOT_ENDED] = this.closeListener.bind(this)
    this.references[tv.freewheel.SDK.EVENT_AD_CLICK] = this.clickListener.bind(this)
    // Register listeners
    for (var key in this.references) {
      this.player.currentAdContext.addEventListener(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()
    // unregister listeners
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.currentAdContext.removeEventListener(key, this.references[key])
      }
      this.references = []
    }
  },

  slotListener: function (e) {
    var position = e.slot.getTimePositionClass()
    this.disable = false
    if (position === "POSTROLL") {
      this.position = "post"
    } else if (position === "MIDROLL") {
      this.position = "mid"
    } else if (position === "PREROLL") {
      this.position = "pre"
    } else {
      this.disable = true
    }
    if (!this.disable) {
      this.titles = e.slot.getAdInstances()
      if (this.plugin.getAdapter()) {
        this.plugin.getAdapter().unregisterListeners()
      }
      if (!this.plugin.isInitiated && !this.plugin.isStarted) {
        if (this.plugin.getAdapter()) {
          this.plugin.getAdapter().fireInit()
        } else {
          this.plugin.fireInit()
        }
      }
      this.fireInit()
      this.fireJoin()
    }
  },
  playListener: function (e) {
    if (this.disable) return null
    this.fireStart()
    this.fireJoin()
  },
  pauseListener: function (e) {
    this.firePause()
  },
  resumeListener: function (e) {
    this.playListener()
    this.fireResume()
  },
  endedListener: function (e) {
    this.fireStop()
  },
  skipListener: function (e) {
    this.fireStop({ skipped: true })
  },
  logListener: function (e) {
    youbora.Log.debug(e.subType)
  },
  clickListener: function (e) {
    this.fireClick()
  },
  closeListener: function (e) {
    if (this.plugin.getAdapter()) {
      this.plugin.getAdapter().registerListeners()
    }
    if (this.position === "post" && !this.disable) {
      this.plugin.fireStop({ end: true })
    }
  }
})

module.exports = youbora.adapters.Freewheel



//////////////////
// WEBPACK FOOTER
// ./src/adapter.js
// module id = 27
// module chunks = 0